import { type ConfirmParam, ConfirmTypeEnum, type RepoConfirm } from '../types/Confirm';
import type { Security } from '../types/Security';
import { SubProductTypeEnum } from '../types/types';

export function hasConfirmParam(param: Partial<ConfirmParam> | undefined): param is ConfirmParam {
  return param?.Confirm != null && param.ConfirmType != null;
}

export function getConfirmParam(entity: Partial<ConfirmParam> | undefined): ConfirmParam | undefined {
  if (hasConfirmParam(entity)) {
    return { Confirm: entity.Confirm, ConfirmType: entity.ConfirmType };
  }

  return undefined;
}

export function getRepoConfirm(entity: Partial<ConfirmParam> | undefined): RepoConfirm | undefined {
  const confirm = getConfirmParam(entity);
  if (confirm?.ConfirmType === ConfirmTypeEnum.RepoConfirm) {
    return confirm.Confirm;
  }

  return undefined;
}

export function isPriceForSecurityRate(security: Security | undefined): boolean {
  if (security?.SubProductType === SubProductTypeEnum.OTCRepo) {
    return true;
  }

  return false;
}
